//
import WhProduct from '@/models/Warehouse/WhProduct'

//
import DetailPurchaseOrder from '@/models/Purchase/PchDetailPurchaseOrder'

/**
 * This class describes a wh product.
 *
 * @class      WhProduct (name)
 */
export default class WhProductToSearch extends WhProduct {

    /**
     * default enpoint appends (empty)
     */
    static appends = []

    /**
     * default enpoint includes (empty)
     */
    static includes = []
}
